import { render, staticRenderFns } from "./tp-sales.vue?vue&type=template&id=bcf2f38c&scoped=true"
import script from "./tp-sales.vue?vue&type=script&lang=js"
export * from "./tp-sales.vue?vue&type=script&lang=js"
import style0 from "./tp-sales.vue?vue&type=style&index=0&id=bcf2f38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf2f38c",
  null
  
)

export default component.exports